module.exports = __webpack_public_path__ + "static/media/kizuna-narrow.ca260556.png";